import { useMutation } from '@tanstack/react-query';
import { inferenceHttp } from '@/lib/api/http-client';

interface GenerateQuestionsRequest {
  topic: string;
  brandName?: string;
  context?: string;
  analysisId?: string;
}

interface GenerateQuestionsResponse {
  questions: string[];
}

const generateQuestions = async (
  payload: GenerateQuestionsRequest,
): Promise<GenerateQuestionsResponse> => {
  const response = await inferenceHttp.post({
    url: '/api/v1/focus-groups/generate-questions',
    body: payload,
  });
  return response.data as GenerateQuestionsResponse;
};

export const useGenerateQuestions = () => {
  return useMutation({
    mutationFn: generateQuestions,
  });
};
